export enum FontFaces {
  SERIF = 'serif',
  EASY_READ = 'easy-read',
}

export const DEFAULT_FONT_FACE = FontFaces.EASY_READ;
